const Telchan = {
  env: 'production',
};
export{Telchan};
